import { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useBreadcrumbs } from '../../../../components/ui/breadcrumps/breadcrumbsContext';
import InstanceHistoryTimeline from '../../../../components/ui/instanceHistoryTimeline/instanceHistoryTimeline.component';
import { basicInfoContainerStyle } from '../../../../styles/commonStyles';

export const JobHistory = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { setOverride, clearOverride } = useBreadcrumbs();

  useEffect(() => {
    if (!id) {
      return undefined;
    }

    const historyPath = `/service/jobs/${id}/history`;
    setOverride(historyPath, t('Job History'));

    return () => {
      clearOverride(historyPath);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, t]);

  return (
    <Box sx={basicInfoContainerStyle}>
      <Typography variant="h6" sx={{ fontWeight: 600 }}>
        {t('Job History')}
      </Typography>
      {id && <InstanceHistoryTimeline modelName="job" objectId={id} refreshEventName="jobUpdated" />}
    </Box>
  );
};
